const GET_RECOMMENDATIONS = 'getRecommendations';

export default GET_RECOMMENDATIONS;
